import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import { avatarFallback } from '../../components/ui/avatarFallback';
import '../../components/ui/avatar.css';
import './feedModal.css';

interface BlockUserModalProps {
  username: string;
  avatarUrl?: string | null;
  /** Stable identity behind the fallback color; the name is used without it. */
  seed?: string | number | null;
  isBlocked?: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function BlockUserModal({
  username,
  avatarUrl,
  seed,
  isBlocked = false,
  loading = false,
  onClose,
  onConfirm,
}: BlockUserModalProps) {
  const { t } = useTranslation();

  const title = isBlocked
    ? t('profile.unblock.title', { name: username })
    : t('profile.block.title', { name: username });
  const description = isBlocked
    ? t('profile.unblock.description', { name: username })
    : t('profile.block.description');
  const confirmLabel = isBlocked ? t('profile.unblock.confirm') : t('profile.block.block');

  const { initial, tone } = avatarFallback({ seed, name: username });

  return (
    <Modal
      title={title}
      onClose={loading ? () => undefined : onClose}
      labelledBy="block-user-modal-title"
      className="feed-prompt-modal"
    >
      <div className="feed-prompt">
        {avatarUrl ? (
          <img className="feed-prompt__media" src={avatarUrl} alt="" />
        ) : (
          <span className="feed-prompt__media feed-prompt__media--initials" data-avatar-tone={tone} aria-hidden>
            {initial}
          </span>
        )}
        <div className="feed-prompt__copy">
          {/* The dialog is already named by the header heading Modal renders. */}
          <p className="feed-prompt__title" aria-hidden="true">{title}</p>
          <p className="feed-prompt__message">{description}</p>
        </div>
        <div className="feed-prompt__actions">
          <Button variant="ghost" size="md" fullWidth onClick={onClose} disabled={loading}>
            {t('common.buttons.cancel')}
          </Button>
          <Button size="md" fullWidth onClick={onConfirm} disabled={loading}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
